import Splide from '@splidejs/splide';

const slider1 = document.querySelector('#slider-one');
const slider2 = document.querySelector('#slider-two');
const slider3 = document.querySelector('#slider-three');
const slider4 = document.querySelector('#slider-four');
const slider5 = document.querySelector('#slider-five');
const slider6 = document.querySelector('#slider-six');
const slider7 = document.querySelector('#slider-seven');
const slider8 = document.querySelector('#slider-eight');

const breakpoints = {
  800: {
    perPage: 1,
    perMove: 1,
  },
  1036: {
    perPage: 2,
    perMove: 1,
  },
};

const classes = {
  prev: 'splide__arrow--prev jo-prev-arrow',
  next: 'splide__arrow--next jo-next-arrow',
  pagination: 'splide__pagination jo-pagination',
  page: 'splide__pagination__page jo-pagination-page',
};

const splide1 = new Splide(slider1, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});

const splide2 = new Splide(slider2, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide3 = new Splide(slider3, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide4 = new Splide(slider4, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide5 = new Splide(slider5, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide6 = new Splide(slider6, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide7 = new Splide(slider7, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide8 = new Splide(slider8, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});

splide1.mount();
splide2.mount();
splide3.mount();
splide4.mount();
splide5.mount();
splide6.mount();
splide7.mount();
splide8.mount();
